import { HiddenVisually, Loader, ContentBlock, Box } from 'braid-design-system';

import { StartOfContentTarget } from 'src/modules/ScreenReader/StartOfContentTarget';

const PageLoader = () => (
  <Box
    paddingTop="xxlarge"
    paddingBottom="xxlarge"
    marginTop="xxlarge"
    marginBottom="xxlarge"
  >
    <ContentBlock>
      <StartOfContentTarget>
        <HiddenVisually>Page Loading</HiddenVisually>
      </StartOfContentTarget>
      <Box display="flex" justifyContent="center">
        <Loader size="large" />
      </Box>
    </ContentBlock>
  </Box>
);

export default PageLoader;
